<template>
  <mock-up-main>
                <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value?.visitName || 'کیوآر متن'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="value?.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>


    <v-fade-transition>
      <div 
        v-if="showSplash" 
        class="splash-screen d-flex flex-column justify-center align-center w-100 h-100 position-absolute"
        style="z-index: 100; background: rgba(255,255,255,0.85); backdrop-filter: blur(10px); top: 0; left: 0;"
      >
        <img 
          v-if="value?.photo?.welcome" 
          :src="value.photo.welcome" 
          alt="Welcome" 
          class="welcome-img zoom-in-anim"
        />
        <atom-spinner v-else :animation-duration="1000" :size="70" :color="pallete.headColor || '#1976d2'" />
      </div>
    </v-fade-transition>

    <div class="d-flex flex-column h-100 position-relative w-100 main-container">
      
      <!-- دکمه شناور شبکه‌های اجتماعی -->
      <floating-btn
        v-if="value?.socialMedia && Object.keys(value.socialMedia).length > 0"
        v-model="value.socialMedia"
        :color="pallete.headColor || '#1AD6D8'"
        class="position-absolute hover-scale"
        style="top: 20px; right: 20px; z-index: 20;"
      />

      <!-- بدنه اصلی (بکگراند داینامیک) -->
      <div 
        class="bg-layer"
        :style="{ background: mainBackground }"
      ></div>
      <div v-if="backgroundImage" class="bg-overlay"></div>

      <!-- محتوای اسکرول شونده -->
      <v-card
        flat
        class="content-wrapper overflow-y-auto hide-scrollbar px-5 pt-8" 
        style="background: transparent; color: inherit;"
      >
        <drag-list v-model="draggingKeys" class="pb-16">
          <template v-slot:default="{ item, index }">
            <div 
              :key="item.name || item" 
              class="drag-item-wrapper mb-6 w-100 position-relative slide-up-anim" 
              :style="{ animationDelay: `${(index || 0) * 0.15}s` }"
            >

              <!-- ۱. پروفایل و عنوان (طراحی هدر ویژه) -->
              <template v-if="(item.name || item) === 'profile' && (value?.photo?.profile||value?.subtitle || value?.organizationName)">
                <div class="modern-glass-card profile-card d-flex flex-column align-center text-center pb-6 pt-10 px-5 mt-14">
                  
                  <!-- تصویر پروفایل با افکت حلقه نوری -->
                  <div class="avatar-ring" :style="{ background: pallete.headColor }" v-if="value?.photo?.profile">
                    <div class="avatar-wrapper" v-if="value?.photo?.profile">
                      <img :src="value.photo.profile" alt="Profile" />
                    </div>
                  </div>

                  <h2 
                    class="font-weight-black mt-5 text-h5 text-truncate w-100 text-shadow" v-if="value?.organizationName"
                    :style="{ color: pallete.textColor }"
                  >
                    {{ value?.organizationName }}
                  </h2>

                  <div 
                    v-if="value?.subtitle" 
                    class="subtitle-badge mt-2 px-4 py-1"
                    :style="{ background: 'rgba(255,255,255,0.15)', color: pallete.textColor }"
                  >
                    <span class="font-weight-medium text-caption">{{ value.subtitle }}</span>
                  </div>

                </div>
              </template>

              <!-- ۲. متن اصلی / درباره ما -->
              <template v-if="(item.name || item) === 'about' && value?.aboutUs">
                <div class="modern-glass-card pa-6">
                  <div class="d-flex align-center mb-4">
                    <div class="icon-box elevation-2" :style="{ background: pallete.headColor }">
                      <v-icon small color="#fff">mdi-text-box-outline</v-icon>
                    </div>
                    <span class="text-subtitle-1 font-weight-bold ml-3 text-shadow" :style="{ color: pallete.textColor }"></span>
                  </div>
                  <p 
                    class="text-justify mb-0 text-body-2 opacity-90" 
                    :style="{ color: pallete.textColor }"
                    style="white-space: pre-line; line-height: 2.2;"
                  >
                    {{ value.aboutUs }}
                  </p>
                </div>
              </template>

              <!-- ۳. فیلدهای اضافه متنی / لینک‌ها -->
              <template v-if="(item.name || item) === 'extraFields' && (value?.extraFields && value.extraFields.length > 0)">
                <div class="extra-fields-container mt-2" v-if="value.extraFields.length>0 && (value.extraFields[0].icon!=='' || value.extraFields[0].name!=='' ||value.extraFields[0].value!==''|| value.extraFields[0].link!=='')">
                
              
                  <div 
                    v-for="(field, fIdx) in value.extraFields" 
                    :key="fIdx" 
                    class="modern-glass-card list-item-card pa-4 mb-4 d-flex align-start"
                  >
                    <!-- آیکون فیلد -->
                    <div v-if="field.icon" class="icon-box-small shrink-0 mt-1" :style="{ color: pallete.headColor, background: 'rgba(255,255,255,0.2)' }">
                      <v-icon size="20" :color="pallete.textColor">{{ field.icon }}</v-icon>
                    </div>
                    
                    <!-- محتوای فیلد -->
                    <div class="flex-grow-1 mr-4 ml-1">
                      <p 
                        class="mb-0 text-body-2 text-justify font-weight-medium opacity-90" 
                        :style="{ color: pallete.textColor }"
                        style="white-space: pre-line; line-height: 2;"
                      >
                        {{ field.value }}
                      </p>
                      
                      <!-- دکمه لینک مدرن -->
                      <v-btn
                        v-if="field.type === 'link' && field.link"
                        :href="field.link"
                        target="_blank"
                        small
                        depressed
                        class="modern-btn mt-4 px-6 rounded-pill"
                        :style="{ background: pallete.headColor, color: '#fff' }"
                      >
                        <span class="font-weight-bold text-caption">مشاهده لینک</span>
                        <v-icon right small>mdi-open-in-new</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </template>

            </div>
          </template>
        </drag-list>
        
        <div style="height: 60px; width: 100%;"></div>
      </v-card>

      <!-- فوتر شیشه‌ای چسبیده به پایین -->
      <div class="modern-footer w-100 position-absolute d-flex flex-column align-center py-3">        
        <div class="d-flex align-center justify-center opacity-80 hover-bright" @click="openLink">
                    <img src="media/cr_logo.webp" alt="Logo" height="18" style="filter: brightness(0) invert(1);" />
          <span class="text-caption font-weight-bold mr-2" :style="{ color: pallete.textColor }">
            قدرت گرفته از کیوآر لند
          </span>
        </div>
      </div>

    </div>
  </mock-up-main>
</template>

<script>
import DragList from "@/view/pages/qrland/dragList"; 
import FloatingBtn from "./floatingBtn.vue";
import ViewSocial from "@/view/pages/otherQrTypes/socialMedia/component/viewSocial";
import MockUpMain from "../../../businessPage/components/mockUp";
import { AtomSpinner } from "epic-spinners"; 
import { Bus } from "@/main";
import UniversalQrModal from "../../../../components/UniversalQrModal.vue";

export default {
  name: "TextMobile",
  components: {
    MockUpMain,
    DragList,
    ViewSocial,
    FloatingBtn,
    AtomSpinner,
    UniversalQrModal
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    orders: {
      type: Array,
      default: () => []
    },
    qrSvgDataUrl: {
      type: String,
      default: "",
    },

  },
  data() {
    return {
      showSplash: false,
      showQrDialog: false,
    };
  },
  methods:{
  openLink(){
    window.open('https://qrland.ir', '_blank');
  },

  },
  computed: {
    primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },

    draggingKeys: {
      get() {
        return this.orders && this.orders.length > 0 
          ? this.orders 
          : [{ name: 'profile' }, { name: 'about' },{ name: 'extraFields' }];
      },
      set(val) {
        this.$emit('update:orders', val);        
      }
    },
    pallete() {
      return this.value?.pallete || {
        bodyColor: '#1e3c72',
        headColor: '#1AD6D8',
        textColor: '#ffffff'
      };
    },
    backgroundImage() {
      return this.value?.photo?.headBackground || "";      
    },
    mainBackground() {
      return this.backgroundImage 
        ? `url(${this.backgroundImage}) no-repeat center center / cover` 
        : this.pallete.bodyColor;
    }
  },
  mounted() {
    Bus.$on("showMe", () => {
      this.showSplash = true;
      setTimeout(() => {
        this.showSplash = false;
      }, 1500); 
    });
  }
};
</script>

<style scoped>
/* ساختار اصلی */
.main-container {
  overflow: hidden;
  background-color: #f5f7fa;
  border-radius: inherit;
}

.bg-layer {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 0;
  transition: all 0.5s ease;
}

.bg-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.4) 100%);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 1;
}

.content-wrapper {
  position: relative;
  z-index: 2;
  height: 100%;
}

/* اسکرول‌بار مخفی */
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Glassmorphism فوق مدرن */
.modern-glass-card {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-top: 1px solid rgba(255, 255, 255, 0.5); /* 3D effect */
  border-left: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 28px;
  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s ease;
}

.list-item-card:hover {
  transform: translateY(-3px) scale(1.01);
  background: rgba(255, 255, 255, 0.22);
  box-shadow: 0 15px 45px -10px rgba(0, 0, 0, 0.3);
}

/* آواتار و حلقه رنگی داینامیک */
.avatar-ring {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  position: absolute;
  top: -48px;
  left: 50%;
  transform: translateX(-50%);
  padding: 4px; /* ضخامت حلقه رنگی */
  box-shadow: 0 8px 25px rgba(0,0,0,0.25);
  z-index: 5;
}

.avatar-wrapper {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #fff;
  overflow: hidden;
  border: 2px solid #fff;
}

.avatar-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.profile-card:hover .avatar-wrapper img {
  transform: scale(1.1);
}

/* متن‌ها و آیکون‌ها */
.text-shadow {
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}

.subtitle-badge {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.icon-box {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, rgba(255,255,255,0.2), rgba(255,255,255,0));
}

.icon-box-small {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(255,255,255,0.3);
}

/* دکمه‌ها */
.modern-btn {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
  letter-spacing: 0.5px;
}
.modern-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25) !important;
  filter: brightness(1.1);
}

.hover-scale {
  transition: transform 0.3s ease;
}
.hover-scale:hover {
  transform: scale(1.1);
}

/* فوتر */
.modern-footer {
  bottom: 0; 
  z-index: 10; 
  background: linear-gradient(to top, rgba(0, 0, 0, 0.4), transparent); 
  backdrop-filter: blur(12px); 
  border-top-left-radius: 30px; 
  border-top-right-radius: 30px;
}
.hover-bright {
  transition: opacity 0.3s;
}
.hover-bright:hover {
  opacity: 1 !important;
}

/* انیمیشن‌ها */
.slide-up-anim {
  animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  opacity: 0;
  transform: translateY(30px);
}

@keyframes slideUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.zoom-in-anim {
  max-width: 150px;
  animation: zoomIn 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes zoomIn {
  0% { transform: scale(0.8); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}
.qr-floating-btn {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>
